export default __webpack_public_path__ + "static/bg_joker-ac39b931fd5358892e13f0ead1f1a07b.png";